import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, RefObject } from 'react';
const useIsElementVisible = (element, threshold) => {
  const $ = _c(6);
  const [isVisible, setState] = useState(false);
  let t0;
  if ($[0] !== element.current || $[1] !== threshold) {
    t0 = () => {
      const observer = new IntersectionObserver(t1 => {
        const [entry] = t1;
        setState(entry.isIntersecting);
      }, {
        threshold
      });
      const currentElement = element.current;
      if (currentElement) {
        observer.observe(currentElement);
      }
      return () => {
        if (currentElement) {
          observer.unobserve(currentElement);
        }
      };
    };
    $[0] = element.current;
    $[1] = threshold;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== element || $[4] !== threshold) {
    t1 = [element, threshold];
    $[3] = element;
    $[4] = threshold;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  return isVisible;
};
export default useIsElementVisible;